<template>
  <div>
    <b-card>
      <b-row>
        <b-col cols="12">
          <name-text />
        </b-col>
        <b-col cols="12">
          <phone-number />
        </b-col>
        <b-col cols="12">
          <notes-text />
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import {
  BCard, BRow, BCol,
} from 'bootstrap-vue'
import NameText from '@/views/Defines/Workers/Elements/NameText.vue'
import PhoneNumber from '@/views/Defines/Workers/Elements/PhoneNumber.vue'
import NotesText from '@/views/Defines/Workers/Elements/NotesText.vue'

export default {
  name: 'ItemForm',
  components: {
    NameText,
    PhoneNumber,
    NotesText,
    BCard,
    BRow,
    BCol,
  },
  computed: {
    dataItem() {
      return this.$store.getters['workers/dataItem']
    },
  },
}
</script>
